/*
BEDROCK Core
Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
*/

// core/shortcuts/useShortcuts.js

import { onMounted, onUnmounted } from 'vue'

const shortcuts = new Map()

function normalize(event) {
    const keys = []

    if (event.ctrlKey) keys.push('ctrl')
    if (event.metaKey) keys.push('meta')
    if (event.altKey) keys.push('alt')
    if (event.shiftKey) keys.push('shift')

    keys.push(event.key.toLowerCase())

    return keys.join('+')
}

function handleKeydown(event) {
    const combo = normalize(event)

    if (shortcuts.has(combo)) {
        event.preventDefault()
        const handler = shortcuts.get(combo)
        if (handler) handler()
    }
}

let initialized = false

export function useShortcuts() {

    onMounted(() => {
        if (!initialized) {
            window.addEventListener('keydown', handleKeydown)
            initialized = true
        }
    })

    onUnmounted(() => {
        // bewusst nicht entfernen → globaler Listener
    })

    function register(combo, handler) {
        shortcuts.set(combo.toLowerCase(), handler)
    }

    function unregister(combo) {
        shortcuts.delete(combo.toLowerCase())
    }

    return {
        register,
        unregister
    }
}